import React, { CSSProperties } from 'react'
import clsx from 'clsx'
import styles from './Checkbox.module.sass'
import CheckIcon from 'files/check.svg'
import { Classes, Colors } from '../../../styles'

export interface CheckboxProps {
    value?: boolean,
    intermediate?: boolean,
    minimal?: boolean,
    block?: boolean,
    disabled?: boolean,
    reversed?: boolean,
    className?: string,
    color?: string,
    onChange?: (value: boolean) => void,
}

export const Checkbox: React.FunctionComponent<CheckboxProps> = props => <div
    className={clsx(props.className, styles.checkbox, Classes.touchTarget, {
        [styles.block]: props.block,
        [styles.active]: props.value || props.intermediate,
        [styles.reversed]: props.reversed,
        [styles.disabled]: props.disabled,
    })}
    style={{'--background': props.color ?? Colors.blue} as CSSProperties}
    onClick={() => !props.disabled && props.onChange?.(!props.value)}
>
    <div className={styles.icon}>{props.value && <CheckIcon/>}</div>
    <div className={styles.content}>{props.children}</div>
</div>
